var chunkMapping = {
	"59": [
		24963
	],
	"87": [
		43160
	],
	"287": [
		67381
	],
	"419": [
		13924,
		13978,
		17693,
		20529,
		28122,
		32055,
		33251,
		33457,
		38477,
		48845,
		50688,
		66111,
		66467,
		71753,
		74999,
		76310,
		78784,
		80137,
		81446,
		97465,
		98256
	]
};
var idToExternalAndNameMapping = {
	"13924": [
		"default",
		"./WidgetTitle",
		16329
	],
	"13978": [
		"default",
		"./WidgetBody",
		16329
	],
	"17693": [
		"default",
		"./Selectors",
		41441
	],
	"20529": [
		"default",
		"./PanelItem",
		16329
	],
	"24963": [
		"default",
		"./History",
		41441
	],
	"28122": [
		"default",
		"./LookEmbed",
		35296
	],
	"32055": [
		"default",
		"./WidgetHeaderCollapsable",
		16329
	],
	"33251": [
		"default",
		"./PanelHeader",
		16329
	],
	"33457": [
		"default",
		"./Utils",
		80191
	],
	"38477": [
		"default",
		"./WidgetSettings",
		16329
	],
	"43160": [
		"default",
		"./utils",
		41441
	],
	"48845": [
		"default",
		"./Store",
		80191
	],
	"50688": [
		"default",
		"./WidgetCardCollapsable",
		16329
	],
	"66111": [
		"default",
		"./widgetContext",
		16329
	],
	"66467": [
		"default",
		"./hooks",
		41441
	],
	"67381": [
		"default",
		"./cWrapper",
		41441
	],
	"71753": [
		"default",
		"./WidgetContent",
		16329
	],
	"74999": [
		"default",
		"./ProductPanel",
		16329
	],
	"76310": [
		"default",
		"./router",
		41441
	],
	"78784": [
		"default",
		"./TimezoneSettingsOptionGroup",
		16329
	],
	"80137": [
		"default",
		"./register",
		87883
	],
	"81446": [
		"default",
		"./WidgetBodyCollapsable",
		16329
	],
	"97465": [
		"default",
		"./WidgetHeader",
		16329
	],
	"98256": [
		"default",
		"./WidgetCard",
		16329
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}